import { create } from 'zustand';

const useContributionTrackerPopUpStore = create((set) => ({
  open: false,
  company: {},
  fundraisingOrg: {},
  type: '',
  donationId: null,
  amount: 0,
  currency: 'USD',
  setClose: () => {
    set((state) => ({ ...state, open: false }));
  },
  setOpen: (fundraisingOrg, company, donationId, amount, currency, type) =>
    set(() => ({
      open: true,
      fundraisingOrg,
      company,
      donationId,
      amount,
      currency,
      type,
    })),
}));

export default useContributionTrackerPopUpStore;
